import React from 'react';
const Button = ({ variant = 'primary', size = 'md', icon, iconPosition = 'left', isLoading = false, fullWidth = false, children, className = '', disabled, ...props }) => {
    // Base styles
    const baseStyles = 'font-medium transition-all duration-300 flex items-center justify-center';
    // Size styles
    const sizeStyles = {
        sm: 'px-3 py-1.5 text-xs rounded-md',
        md: 'px-4 py-2 text-sm rounded-md',
        lg: 'px-6 py-3 text-base rounded-md',
        icon: 'p-2 rounded-md'
    };
    // Variant styles
    const variantStyles = {
        primary: 'bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white shadow-md',
        secondary: 'bg-white border border-gray-200 hover:bg-gray-50 text-gray-800 shadow-sm',
        outline: 'bg-transparent border border-gray-300 hover:bg-gray-50 text-gray-700',
        ghost: 'bg-transparent hover:bg-gray-100 text-gray-700',
        link: 'bg-transparent text-orange-500 hover:text-orange-600 underline-offset-2 hover:underline p-0',
        danger: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white shadow-md'
    };
    // Disabled styles
    const disabledStyles = disabled || isLoading ? 'opacity-60 cursor-not-allowed' : '';
    // Full width styles
    const widthStyles = fullWidth ? 'w-full' : '';
    return React.createElement("button", { className: `${baseStyles} ${sizeStyles[size]} ${variantStyles[variant]} ${disabledStyles} ${widthStyles} ${className}`, disabled: disabled || isLoading, ...props },
        isLoading && React.createElement("svg", { className: "animate-spin -ml-1 mr-2 h-4 w-4 text-current", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })),
        icon && iconPosition === 'left' && !isLoading && React.createElement("span", { className: "mr-2" }, icon),
        children,
        icon && iconPosition === 'right' && React.createElement("span", { className: "ml-2" }, icon));
};
export default Button;
